import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@material-ui/core';
import { NumberCell, DateTimeCell } from '../../../../utils/Cells';
import React from 'react';

export function ProposedTable({ list }) {

    return (
        <>
            {(list.length !== 0) ?
                <TableContainer component={Paper}>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow key="header">
                                <TableCell>Dátum</TableCell>
                                <TableCell>Ellenoldal</TableCell>
                                <TableCell>Megjegyzés</TableCell>
                                <TableCell align="right">Összeg</TableCell>
                                <TableCell align="right">Fennmaradó összeg</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.map((row) => (
                                <TableRow key={row.privateId}>
                                    <TableCell> <DateTimeCell value={row.transactionDateTime} /></TableCell>
                                    <TableCell> {row.contraName}</TableCell>
                                    <TableCell>{row.comment}</TableCell>
                                    <TableCell align="right"><NumberCell value={row.amount} /></TableCell>
                                    <TableCell align="right"><NumberCell value={row.remainingAmount} /></TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                : <div className='details'>Nincs</div>}
        </>
    )
}